@if (editMode) {
  <div></div>
}

@if (!editMode) {
  <div class="message-bubble">
    <div class="message-text">{{ messageText }}</div>
  </div>
}
